<template>
  <div class="new_post">
    <form
      class="forms-sample"
      style="border-radius: 10px; border: 1px solid gainsboro"
      :key="this.$route.params.post"
      @submit.prevent="save"
    >
      <h6 class="sub-title mb-3 color-default font-weight-bold">{{ formHeader }}</h6>
      <div class="form-group row">
        <div class="col-md-6">
          <label class="label-form" for="title"
            >Title<span style="color: red">*</span>:</label
          >
          <input type="text" class="form-control" id="title" v-model="postForm.title" />
        </div>

        <div class="col-md-6">
          <label class="label-form" for="htitle"
            >Featured Image <span style="color: red">*</span>:</label
          >
          <div
            class="row"
            v-if="currentImage && !postForm.remove_image && !postForm.caption"
          >
            <div class="col-md-8">
              <img :src="currentImage" alt="post caption" height="200" />
            </div>
          </div>
          <div
            class="row"
            v-if="imagePreview"
            style="margin-top: 15px; text-align: center"
          >
            <div class="col-md-8">
              <img :src="imagePreview" alt="New Image Preview" height="200" />
            </div>
          </div>
          <input type="hidden" v-model="postForm.remove_image" />
          <div class="form-control" style="padding: 6px; margin-top: 15px">
            <input
              type="file"
              ref="caption"
              @change="handleCaptionUpload"
              accept="image/*"
            />
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-6">
          <label class="label-form" for="slug"
            >Slug<span style="color: red">*</span>:</label
          >
          <input type="text" class="form-control" id="slug" v-model="postForm.new_slug" />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6" style="padding-top: 37px">
          <input type="checkbox" v-model="postForm.show_in_admin" />
          Show case study on Admin Panel?
        </div>
        <div class="col-md-6" style="padding-top: 37px">
          <input type="checkbox" v-model="postForm.featured" />
          Make case study featured?
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label class="label-form" for="meta_title">Meta Title:</label>
          <input
            type="text"
            class="form-control"
            id="meta_title"
            v-model="postForm.meta_title"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-6">
          <label class="label-form" for="meta_keyword">Meta keyword:</label>
          <input
            type="text"
            class="form-control"
            id="meta_keyword"
            v-model="postForm.meta_keyword"
          />
        </div>
        <div class="col-md-6">
          <label class="label-form" for="meta_description">Meta Description:</label>
          <input
            type="text"
            class="form-control"
            id="meta_description"
            v-model="postForm.meta_description"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <label class="label-form" for="short_description">Short Description:</label>
          <textarea
            class="form-control"
            id="short_description"
            v-model="postForm.short_description"
          ></textarea>
        </div>
      </div>

      <div class="form-group">
        <label class="label-form" for="description"
          >Body<span style="color: red">*</span>:</label
        >
        <div class="text_editor">
          <tiny-mce-editor :vModelName.sync="postForm.body"></tiny-mce-editor><br />
        </div>
      </div>
      <div class="text-right">

        <button type="submit" class="btn btn-primary" :disabled="mini_loading ? '' : disabled">
          <font-awesome-icon
              v-if="mini_loading"
              icon="spinner"
              style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;"
          />
          Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import TinymceEditor from "../../views/partials/tiny_mce_editor";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    "tiny-mce-editor": TinymceEditor,
  },

  data() {
    return {
      selectedCategories: [],
      productId: localStorage.getItem("product_id"),
      formHeader: "",
      postForm: {
        remove_image: false,
        title: "",
        new_slug: "",
        body: "",
        caption: "",
        meta_title: "",
        meta_description: "",
        meta_keyword: "",
        short_description: "",
        show_in_admin: false,
        featured: false,
      },
      imagePreview: null,
      mini_loading: false,
    };
  },

  computed: {
    caseStudy() {
      return this.$store.getters["caseStudy/caseStudy"];
    },
    currentImage() {
      if (typeof this.$route.params.slug === "undefined") return "";
      return this.caseStudy && this.caseStudy.caption ? this.caseStudy.caption : null;
    },
  },

  created() {
    this.resetForm();
    this.loadCaseStudy();
  },

  methods: {
    handleCaptionUpload(event) {
      const file = this.$refs.caption.files[0];
      this.postForm.caption = file;
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
          this.postForm.remove_image = false;
        };
        reader.readAsDataURL(file);
      }
    },

    loadCaseStudy() {
      this.resetForm();
      if (typeof this.$route.params.slug === "undefined") {
        this.formHeader = "New Case Study";
        return;
      }

      this.formHeader = "Update Case Study";
      this.$store.dispatch("caseStudy/view", this.$route.params.slug).then(() => {
        this.postForm = {
          slug: this.caseStudy.slug,
          new_slug: this.caseStudy.slug.split("-").join(" "),
          title: this.caseStudy.title,
          id: this.caseStudy.id,
          show_in_admin: this.caseStudy.show_in_admin == "1",
          featured: this.caseStudy.featured == "1",
          meta_title: this.caseStudy.meta_title,
          meta_description: this.caseStudy.meta_description,
          meta_keyword: this.caseStudy.meta_keyword,
          short_description: this.caseStudy.short_description,
          body: this.caseStudy.body,
        };
      });
    },

    save() {
      if (!this.validateForm()) return;

      if (typeof this.$route.params.slug === "undefined") {
        this.createCaseStudy(this.postForm);
      } else {
        this.updateCaseStudy(this.postForm);
      }
    },

    validateForm() {
      let requiredFields = [];
      if (typeof this.$route.params.slug === "undefined") {
        requiredFields = ["title", "caption", "new_slug", "body"];
      } else {
        requiredFields = ["title", "new_slug", "body"];
      }

      for (const field of requiredFields) {
        if (field == "body") {
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.postForm.body, "text/html");
          const bodyContent = doc.body.textContent.trim();
          if (!bodyContent) {
            this.$toast.error(`Body field is required.`);
            return false;
          }
        } else {
          if (!this.postForm[field]) {
            if(field == "new_slug") {
          this.$toast.error(`Slug field is required.`);
          } else if(field == "caption") {
          this.$toast.error(`Image field is required.`);
        } else {
            this.$toast.error(
              `${field.charAt(0).toUpperCase() + field.slice(1)} field is required.`
            );
          }
            return false;
          }
        }
      }

      return true;
    },

    createCaseStudy(formData) {
      this.mini_loading = true;
      this.$store
        .dispatch("caseStudy/create", formData)
        .then((response) => {
          if (response.error) {
            this.$toast.error(response.error)
            this.mini_loading = false;
          } else {
            this.$toast.success(`Case study has been saved successfully`);
            this.resetForm();
            this.mini_loading = false;
            this.$router.push("/case-study");
          }
        })
        .catch((error) => {
          this.handleErrorResponse(error);
        });
    },

    updateCaseStudy(post) {
      this.mini_loading = true;
      this.$store
        .dispatch("caseStudy/update", post)
        .then((response) => {
          if (response.data.error) {
            this.$toast.error(response.data.error);
            this.mini_loading = false;
          } else {
            this.$toast.success(`Case Study has been updated successfully`);
            this.resetForm();
            this.mini_loading = false;
            this.$router.push("/case-study");
          }
        })
        .catch((error) => {
          this.handleErrorResponse(error);
        });
    },

    resetForm() {
      this.postForm = {
        title: "",
        new_slug: "",
        body: "",
        caption: "",
        meta_title: "",
        meta_description: "",
        meta_keyword: "",
        short_description: "",
        show_in_admin: false,
        featured: false,
        remove_image: false,
      };
      this.imagePreview = null;
      this.selectedCategories = [];
    },

    handleErrorResponse(error) {
      const response = error.response;
      if (response.data.errors) {
        Object.keys(response.data.errors).forEach((key) => {
          response.data.errors[key].forEach((errorMsg) => {
            this.$toast.error(errorMsg);
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.new_post {
  margin-top: -55px !important;
}
</style>
